const ITEMS = [
  { icon: 'schedule', text: 'Order online and skip the queue' },
  { icon: 'payments', text: 'Pay securely online' },
  { icon: 'restaurant', text: 'Cooked fresh per order' },
  { icon: 'tune', text: 'Spice level on request' },
  { icon: 'location_on', text: 'Kiosk pickup, Beau Vallon' },
];

export default function TrustStrip() {
  return (
    <div
      className="trust-strip"
      style={{
        background: 'var(--teal-dark)',
        padding: 'clamp(1.5rem, 3vw, 2.25rem) 2rem',
      }}
    >
      <div
        style={{
          maxWidth: 'var(--max-width)',
          margin: '0 auto',
          display: 'flex',
          justifyContent: 'center',
          flexWrap: 'wrap',
          gap: 'clamp(1.25rem, 3vw, 2.75rem)',
        }}
      >
        {ITEMS.map((item) => (
          <div
            key={item.text}
            className="trust-strip-item"
            style={{
              display: 'flex',
              alignItems: 'center',
              gap: '1rem',
              color: 'rgba(255,255,255,0.92)',
              maxWidth: 320,
            }}
          >
            <span
              className="material-symbols-outlined"
              aria-hidden="true"
              style={{
                fontSize: 32,
                width: 56,
                height: 56,
                flexShrink: 0,
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                background: 'rgba(255,255,255,0.08)',
                borderRadius: 'var(--radius-sm)',
                color: 'var(--gold-light)',
                fontWeight: 300,
              }}
            >
              {item.icon}
            </span>
            <span
              style={{
                fontSize: 'clamp(1rem, 1.35vw, 1.125rem)',
                fontWeight: 500,
                lineHeight: 1.35,
                letterSpacing: '0.01em',
              }}
            >
              {item.text}
            </span>
          </div>
        ))}
      </div>

      <style>{`
        @media (max-width: 640px) {
          .trust-strip-item {
            max-width: 100% !important;
            width: 100%;
          }
        }
      `}</style>
    </div>
  );
}
